export const PLATFORM_DATABASE_NAMES = Object.freeze({
  publicEvents: "platform-events",
  privateState: "platform-private",
  packages: "napplet-packages",
  nappletState: "napplet-state",
  metadata: "platform-metadata"
} as const);
